import React from 'react'

function Description({description}) {
  return (
    <div className='row p-3'>
      <h6>Description</h6>
      <p style={{ textAlign: 'justify', textIndent: '3rem' }}>
        {description.description?.detailedDescription || 'No description available.'}
      </p>
       <table className="table table-bordered mt-5">
        <tbody>
          <tr>
            <td>Available Quantities</td>
            <td>{description.priceAndQuantity.map((item) => item.quantity).join(", ")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Description